<template>
  <div>
    <div v-if="isLoading == false">
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          height: 50px;
        "
      >
        <img
          src="@/assets/back-office/icons/chevron_icon_left.svg"
          alt=""
          width="30px"
          @click="$router.back()"
          style="cursor: pointer"
        />
        <h2 class="text-xs-center">
          Invoice Detail (ใบแจ้งชำระหนี้ #{{ invoiceDetail.bill_number }})
        </h2>
        <div></div>
      </div>
      <v-card class="mt-3"
        ><v-card-title
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: #ffd600;
            padding-left: 50px;
            padding-right: 50px;
          "
          ><div style="color: #262626; font-size: 22px; font-weight: bold">
            ใบแจ้งหนี้/ใบวางบิล
          </div>
          <img
            src="@/assets/back-office/logo.png"
            alt="weserve"
            width="150px" /></v-card-title
        ><v-card-text style="padding-left: 50px; padding-right: 50px">
          <v-layout wrap>
            <v-flex xs12 sm6>
              <v-layout>
                <v-flex xs3 class="body__content__title">ผู้ออก</v-flex>
                <v-flex xs9 class="body__content__value">{{
                  invoiceDetail.bill_issuer_name
                }}</v-flex></v-layout
              >
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5>
              <v-layout>
                <v-flex xs5 class="body__content__title"
                  >เลขประจำตัวผู้เสียภาษี</v-flex
                >
                <v-flex xs7 class="body__content__value">{{
                  invoiceDetail.bill_issuer_tax_id
                }}</v-flex></v-layout
              ></v-flex
            ></v-layout
          >
          <hr class="new2 my-3" />
          <v-layout wrap>
            <v-flex xs12 sm6>
              <v-layout>
                <v-flex xs5 class="body__content__title">ลูกค้า</v-flex>
                <v-flex xs7 class="body__content__value">{{
                  invoiceDetail.bill_customer_name
                }}</v-flex></v-layout
              >
              <v-layout>
                <v-flex xs5 class="body__content__title">ที่อยู่</v-flex>
                <v-flex xs7 class="body__content__value">{{
                  invoiceDetail.bill_customer_address
                }}</v-flex></v-layout
              >
              <v-layout>
                <v-flex xs5 class="body__content__title"
                  >เลขประจำตัวผู้เสียภาษี</v-flex
                >
                <v-flex xs7 class="body__content__value">{{
                  invoiceDetail.bill_customer_tax_id
                }}</v-flex></v-layout
              >
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5>
              <v-layout>
                <v-flex xs5 class="body__content__title">เลขที่ใบกำกับ</v-flex>
                <v-flex xs7 class="body__content__value">{{
                  invoiceDetail.bill_number
                }}</v-flex></v-layout
              >
              <v-layout>
                <v-flex xs5 class="body__content__title">วันที่ออก</v-flex>
                <v-flex xs7 class="body__content__value">{{
                  moment(invoiceDetail.create_at).format("DD/MM/YYYY")
                }}</v-flex></v-layout
              >
              <v-layout>
                <v-flex xs5 class="body__content__title">ครบกำหนด</v-flex>
                <v-flex xs7 class="body__content__value">{{
                  moment(invoiceDetail.bill_due_date).format("DD/MM/YYYY")
                }}</v-flex></v-layout
              >
            </v-flex></v-layout
          >
          <hr class="my-3" />
          <v-data-table
            hide-actions
            :headers="headers"
            :items="invoiceDetail.bill_detail"
          >
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">
                  {{ props.index + 1 }}
                </td>
                <td class="text-xs-center">
                  {{ props.item.name }}
                </td>
                <td class="text-xs-center">
                  {{ props.item.unit }}
                </td>
                <td class="text-xs-center">
                  {{ props.item.price }}
                </td>
                <td class="text-xs-center">
                  {{ props.item.unit * props.item.price }}
                </td>
              </tr></template
            >
          </v-data-table>
          <v-layout class="mt-3">
            <v-flex
              xs6
              style="display: flex; align-items: flex-end"
              class="body__content__title"
              >ตัวอักษร :
              <span class="body__content__value"
                >({{ invoiceDetail.bill_net_price_text }}).</span
              ></v-flex
            >
            <v-flex xs6>
              <v-layout wrap>
                <v-flex xs6 class="text-xs-right">รวมเป็นเงิน</v-flex>
                <v-flex xs6 class="body__content__value text-xs-right">{{
                  invoiceDetail.bill_amount_price
                }}</v-flex>
                <v-flex xs6 class="text-xs-right"
                  ><span style="text-decoration: underline">หัก</span>
                  ส่วนลด</v-flex
                >
                <v-flex xs6 class="body__content__value text-xs-right">{{
                  invoiceDetail.bill_discount_price
                }}</v-flex>
                <v-flex xs6 class="text-xs-right">ยอดหลังหักส่วนลด</v-flex>
                <v-flex xs6 class="body__content__value text-xs-right">{{
                  invoiceDetail.bill_amount_price -
                  invoiceDetail.bill_discount_price
                }}</v-flex
                ><v-flex xs6 class="text-xs-right"
                  ><span style="text-decoration: underline">หัก</span>
                  เงินมัดจำ</v-flex
                >
                <v-flex xs6 class="body__content__value text-xs-right">{{
                  invoiceDetail.bill_deposit_price
                }}</v-flex>
                <v-flex xs6 class="text-xs-right">จำนวนเงินหลังหักมัดจำ</v-flex>
                <v-flex xs6 class="body__content__value text-xs-right">{{
                  invoiceDetail.bill_amount_price -
                  invoiceDetail.bill_discount_price -
                  invoiceDetail.bill_deposit_price
                }}</v-flex>
                <v-flex xs6 class="text-xs-right"
                  >จำนวนภาษีมูลค่าเพิ่ม 7%</v-flex
                >
                <v-flex xs6 class="body__content__value text-xs-right">{{
                  invoiceDetail.bill_vat_price
                }}</v-flex>
                <v-flex xs6 class="text-xs-right body__content__title"
                  >จำนวนเงินรวมทั้งสิ้น</v-flex
                >
                <v-flex xs6 class="body__content__title text-xs-right">{{
                  invoiceDetail.bill_net_price
                }}</v-flex>
              </v-layout></v-flex
            ></v-layout
          >
        </v-card-text></v-card
      >
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      headers: [
        {
          text: "ลำดับที่",
          align: "center",
          sortable: false,
        },
        {
          text: "รายละเอียด",
          align: "center",
          sortable: false,
        },
        {
          text: "จำนวน",
          align: "center",
          sortable: false,
        },
        {
          text: "หน่วยละ",
          align: "center",
          sortable: false,
        },
        {
          text: "จำนวนเงิน",
          align: "center",
          sortable: false,
        },
      ],
      isLoading: false,
      invoiceDetail: {
        bill_id: null,
        bill_type: {
          bill_type_id: null,
          bill_type_name: "",
        },
        bill_provider: "manager",
        bill_number: "",
        bill_description: "",
        bill_issuer_name: "",
        bill_issuer_address: "",
        bill_issuer_tax_id: "",
        bill_customer_name: "",
        bill_customer_address: "",
        bill_customer_tax_id: "",
        bill_detail: [
          {
            name: "",
            unit: 0,
            price: 0,
          },
          {
            name: "",
            unit: 0,
            price: 0,
          },
        ],
        bill_user_partner_id: null,
        bill_district_id: null,
        bill_amount_price: 0,
        bill_discount_price: 0,
        bill_deposit_price: 0,
        bill_vat_price: 0,
        bill_net_price: 0,
        bill_net_price_text: "",
        bill_due_date: null,
        bill_status: 1,
      },
    };
  },
  methods: {
    ...mapActions({
      getInvoiceManagerByID: "invoice/fetchInvoiceManagerByID",
    }),
  },
  async created() {
    this.isLoading = true;
    this.invoiceDetail = await this.getInvoiceManagerByID({
      manager_id: this.$route.params.manager_id,
      invoice_id: this.$route.params.invoice_id,
    });
    this.isLoading = false;
  },
};
</script>

<style scoped>
.body__content__title {
  font-size: 14px;
  font-weight: bold;
  color: #262626;
}

.body__content__value {
  font-size: 14px;
  color: #707070;
  font-weight: 500;
}

hr.new2 {
  border-top: 1px dashed #9e9e9e;
}
</style>
